import { useCallback, useEffect, useState } from "react";
import { getPermsCatalog } from "../api/permissions";

// جالب كتالوج الصلاحيات (وحدات + قائمة موحّدة) مع إعادة تحميل.
export const usePermsCatalog = () => {
  const [modules, setModules] = useState({});
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await getPermsCatalog();
      setModules(d.modules || {});
      setCount(d.count || 0);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  return { modules, count, loading, reload: load };
};
